import Component from "@glimmer/component";
import { Task, dropTask } from "ember-concurrency";
import { service } from "@ember/service";
import { arg } from "glesys-controlpanel/utils/arg";
import { instanceOf, shape } from "prop-types";
import { stringable } from "glesys-controlpanel/utils/prop-types";

export default class ModalsConfirm extends Component {
  @service modal;

  @arg(
    shape({
      task: instanceOf(Task).isRequired,
      text: stringable,
      titleText: stringable,
      buttonText: stringable,
      buttonColor: stringable,
    }),
  )
  params;

  get task() {
    return this.params.task;
  }

  get text() {
    return this.params.text;
  }

  get titleText() {
    return this.params.titleText;
  }

  get buttonText() {
    return this.params.buttonText;
  }

  get buttonColor() {
    return this.params.buttonColor ?? "red";
  }

  submitTask = dropTask(async () => {
    await this.task.perform();
    this.modal.close();
  });
}
